import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { translate } from "@/i18n/runtime";

const routes: RouteRecordRaw[] = [
  { path: "/", redirect: "/home" },
  { path: "/home", name: "home", component: () => import("@/pages/HomePage.vue"), meta: { title: "Home" } },
  { path: "/download", name: "download", component: () => import("@/pages/DownloadPage.vue"), meta: { title: "Download" } },
  { path: "/library", name: "library", component: () => import("@/pages/LibraryPage.vue"), meta: { title: "Library" } },
  { path: "/search", name: "search", component: () => import("@/pages/SearchPage.vue"), meta: { title: "Search" } },
  { path: "/games/:id", name: "detail", component: () => import("@/pages/DetailPage.vue"), meta: { title: "Game" } },
  { path: "/games/:id/reviews", name: "reviews", component: () => import("@/pages/ReviewsPage.vue"), meta: { title: "Reviews" } },
  { path: "/inbox", name: "inbox", component: () => import("@/pages/InboxPage.vue"), meta: { title: "Inbox", auth: true } },
  { path: "/profile", name: "profile", component: () => import("@/pages/ProfilePage.vue"), meta: { title: "Profile" } },
  { path: "/favorites", name: "favorites", component: () => import("@/pages/FavoritesPage.vue"), meta: { title: "Saved games", auth: true } },
  { path: "/history", name: "history", component: () => import("@/pages/HistoryPage.vue"), meta: { title: "Recently played", auth: true } },
  { path: "/friends", name: "friends", component: () => import("@/pages/FriendsPage.vue"), meta: { title: "Friends", auth: true } },
  { path: "/games/:id/saves", name: "saves", component: () => import("@/pages/SavesPage.vue"), meta: { title: "Cloud saves", auth: true } },
  { path: "/membership", name: "membership", component: () => import("@/pages/MembershipPage.vue"), meta: { title: "Membership", auth: true } },
  { path: "/settings", name: "settings", component: () => import("@/pages/SettingsPage.vue"), meta: { title: "Settings" } },
  { path: "/settings/controls", name: "control-settings", component: () => import("@/pages/ControlSettingsPage.vue"), meta: { title: "Game controls" } },
  { path: "/settings/safety", name: "safety", component: () => import("@/pages/SafetyPage.vue"), meta: { title: "Safety", auth: true } },
  { path: "/login", name: "login", component: () => import("@/pages/LoginPage.vue"), meta: { title: "Sign in", fullscreen: true } },
  { path: "/play/:id", name: "play", component: () => import("@/pages/PlayPage.vue"), meta: { title: "Cloud play", auth: true, fullscreen: true } },
  { path: "/:pathMatch(.*)*", redirect: "/home" },
];

export const router = createRouter({
  history: createWebHistory(), routes,
  scrollBehavior(_to, _from, saved) { return saved ?? { top: 0 }; },
});

router.beforeEach(async (to) => {
  document.title = `${translate(String(to.meta.title ?? "GameGlee"))} · GameGlee`;
  const auth = useAuthStore();
  await auth.bootstrap();
  if (to.meta.auth && !auth.isAuthenticated) {
    return { name: "login", query: { redirect: to.fullPath } };
  }
  return true;
});
